import ContenitoreCard from "./ContenitoreCard";
export default ContenitoreCard;